var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramDetailsCsvFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.394,
    height: 26.457,
    viewBox: "0 0 23.394 26.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9269",
    "data-name": "Group 9269",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-file-1036456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12264",
    "data-name": "Path 12264",
    d: "M230.63,152.606H248.6v-16.04l-6.837-6.837H230.63Z",
    transform: "translate(-230.63 -129.73)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12265",
    "data-name": "Path 12265",
    d: "M479.279,522.522h9.466",
    transform: "translate(-473.231 -512.968)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12266",
    "data-name": "Path 12266",
    d: "M335.135,522.522h1.315",
    transform: "translate(-332.593 -512.968)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12267",
    "data-name": "Path 12267",
    d: "M479.279,677.477h9.466",
    transform: "translate(-473.231 -664.154)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12268",
    "data-name": "Path 12268",
    d: "M335.135,677.477h1.315",
    transform: "translate(-332.593 -664.154)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12269",
    "data-name": "Path 12269",
    d: "M479.279,828.828h9.466",
    transform: "translate(-473.231 -811.824)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12270",
    "data-name": "Path 12270",
    d: "M335.135,828.828h1.315",
    transform: "translate(-332.593 -811.824)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9268",
    "data-name": "Group 9268",
    transform: "translate(13.042 16.105)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_493",
    "data-name": "Ellipse 493",
    cx: 4.926,
    cy: 4.926,
    r: 4.926,
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9267",
    "data-name": "Group 9267",
    transform: "translate(2.769 2.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12271",
    "data-name": "Path 12271",
    d: "M0,0V4.223",
    transform: "translate(4.223 2.111) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12272",
    "data-name": "Path 12272",
    d: "M3353-3503.382v4.223",
    transform: "translate(-3350.889 3503.382)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramDetailsCsvFile);
export default __webpack_public_path__ + "static/media/programDetailsCsvFile.b60f6e92702028978c4a24a14db8da1b.svg";
export { ForwardRef as ReactComponent };